<template>
  <NuxtLoadingIndicator />

  <ConfigProvider>
    <OpacityOverlay />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <LoginModal />
    <ScrollToTop />
    <CookieConsentModal />
    <ModalsContainer />
  </ConfigProvider>
</template>

<script setup lang="ts">
import { ConfigProvider } from 'reka-ui'
import { ModalsContainer } from 'vue-final-modal'
import OpacityOverlay from '~/components/app/OpacityOverlay.vue'
import LoginModal from '~/components/login-modal/LoginModal.vue'
import ScrollToTop from '~/components/scroll-to-top/ScrollToTop.vue'
import CookieConsentModal from '~/components/cookie-consent/CookieConsentModal.vue'

provideHeadlessUseId(() => useId())
</script>
